import { ColdStoragePollImpl } from '@mimir/client-common/coldStorage/coldStoragePollImpl';
import type { ColdStoragePollOps } from '@mimir/client-common/coldStorage/coldStoragePollOps';
import { getItems } from '@mimir/web/api/globalClientGetItems';
import { getItem } from '../util/api';
import { ConsoleLogger } from '@mimir/common/util/logging';

const pollDurationInSeconds = 20;
const pollDurationNonExpeditedInMinutes = 10;

/**
 * Since the ColdStoragePollImpl objects use polling logic,
 * we use a singleton to make sure to reuse the polling
 * objects to share polling across all restore operations.
 */
interface ColdStoragePollers {
  expeditedPollOps: ColdStoragePollOps;
  nonExpeditedPollOps: ColdStoragePollOps;
}
let coldStoragePollers: ColdStoragePollers | undefined;


export function getColdStoragePollers(): ColdStoragePollers {
  if (coldStoragePollers === undefined) {
    const logger = new ConsoleLogger();

    const expeditedPollOps = new ColdStoragePollImpl(
      logger,
      pollDurationInSeconds * 1000,
      (itemIds: string[]) => getItems(itemIds, ['id', 'archiveInfo']),
      (itemId: string) => getItemHighresUrl(itemId),
      (callback: () => void, md: number) => window.setInterval(callback, md),
      (handle: any) => window.clearInterval(handle),
    );

    const nonExpeditedPollOps = new ColdStoragePollImpl(
      logger,
      pollDurationNonExpeditedInMinutes * 60 * 1000,
      (itemIds: string[]) => getItems(itemIds, ['id', 'archiveInfo']),
      (itemId: string) => getItemHighresUrl(itemId),
      (callback: () => void, md: number) => window.setInterval(callback, md),
      (handle: any) => window.clearInterval(handle),
    );
    coldStoragePollers = {
      expeditedPollOps,
      nonExpeditedPollOps,
    };
  }

  return coldStoragePollers;
}

async function getItemHighresUrl(itemId: string): Promise<string | undefined> {
  const item = await getItem(itemId);
  return item.highRes;
}
